import LoginStyleConfig from './index';

// 在ebComStyleConfigs中统一导出所有组件的样式
export default {
    LoginStyleConfig, //这个名称对应组件样式维护的前端组件key
};